const PHONE_BODY_COLOR = '#1d1d1b';

const landingHeroStyle = (theme) => ({
  landingBox: {
    width: '100%',
    height: '100vh',
    minHeight: 930,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    background: `linear-gradient(
      -310deg,
      #cb9da3,
      #f5e3e5
    )`,

    '.headerText': {
      fontSize: '3.3rem',
      lineHeight: '2.9rem',
      fontWeight: 'bold',
      maxWidth: '90%',
      [theme.breakpoints.down('sm')]: {
        fontSize: '2.6rem',
        lineHeight: '2.4rem'
      }
    },

    '.subHeaderText': {
      fontSize: '1.9rem',
      lineHeight: '1.8rem',
      fontWeight: 'bold',
      maxWidth: '90%',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.8rem',
        lineHeight: '1.7rem'
      }
    }
  },

  demoBox: {
    display: 'flex',
    position: 'relative',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 30,
    paddingBottom: 30,
    flexDirection: 'row'
  },

  ctaBox: {
    marginTop: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',

    small: {
      fontSize: '0.9rem'
    }
  },

  phone: {
    position: 'relative',
    zIndex: 10,
    filter: 'drop-shadow(0 10px 10px #1a1a1a)',

    [theme.breakpoints.down('md')]: {
      filter: 'drop-shadow(0 20px 20px #1a1a1a)'
    },

    [theme.breakpoints.down('sm')]: {
      filter: 'drop-shadow(0 50px 50px #1a1a1a)'
    },

    '.phoneScreen': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 25,
      overflow: 'hidden',
      position: 'absolute',
      top: 12,
      right: 12,
      left: 12,
      bottom: 12,

      '.cameraMode': {
        width: '100%',
        height: '100%',

        '.topBar': {
          background: theme.palette.primary.main,
          height: 30,
          minHeight: 30,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        },
        '.cameraScreen': {
          display: 'flex',
          flexGrow: 1,
          background: '#FFF',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden',

          '.floor': {
            position: 'absolute'
          },

          '.screenSwiper': {
            height: '100%',
            width: '100%'
          }
        },
        '.bottomBar': {
          background: PHONE_BODY_COLOR,
          padding: 10,
          display: 'flex',
          justifyContent: 'center',

          '.shutter': {
            width: 40,
            height: 40,
            borderRadius: '50%',
            background: '#FFF',
            display: 'flex',
            alignItems: 'center',
            // boxShadow: `
            //   inset 0px 0px 0px 3px #FFF,
            //   inset 0px 0px 0px 5px ${PHONE_BODY_COLOR}
            // `
            '.inner': {
              margin: 'auto',
              background: '#FFF',
              borderColor: 'black',
              borderStyle: 'solid',
              height: 34,
              width: 34,
              borderRadius: '50%'
            }
          }
        }
      }
    }
  },

  phoneSlide: {
    height: '100%',
    width: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',

    '.gridBackground': {
      background: 'url("/img/marketing/landing/section_hero_demo/checker_bkgrnd.gif")',
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      height: '100%',
      width: '100%'
    },

    '.ogBackground': {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: -1,
      right: -1
    },

    '.ogShadow': {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      height: '100%',
      width: '100%'
    },

    '.imageArea': {
      display: 'flex',
      width: '100%',
      flexGrow: 1
    },

    '.cameraFlash': {
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      height: '100%',
      width: '100%',
      background: '#FFF',
      zIndex: 3
    },

    '.editScreen': {
      height: '100%',
      width: '100%',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },

    '.laser': {
      height: 4,
      top: 0,
      width: '100%',
      background: theme.palette.primary.main,
      position: 'absolute',
      zIndex: 300
    },

    '.cameraControls': {
      width: 25,
      height: 25,
      position: 'absolute',
      bottom: 20,
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      alignContent: 'center',
      justifyContent: 'center',

      '.MuiAvatar-root': {
        backgroundColor: 'rgba(255, 255, 255, 0.4)',
        fontSize: 9,
        width: 25,
        height: 25
      }
    }
  },

  book: {
    display: 'flex',
    borderRadius: 5,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxShadow: `
      // main drop
      0 0 45px rgba(18, 9, 4, .3),

      inset -2px 2px 4px rgba(255, 255, 255, 0.1),

      rgba(18, 9, 4, 0.4) 0px 2px 4px,
      rgba(18, 9, 4, 0.3) 0px 7px 13px -3px,
      rgba(18, 9, 4, 0.2) 0px -2px 0px inset,

      rgba(18, 9, 4, 0.35) 0px 10px 10px,
      rgba(18, 9, 4, 0.25) 0px 10px 10px,
      rgba(18, 9, 4, 0.25) 0px 10px 10px
    `,

    '.spine': {
      position: 'absolute',
      left: '50%',
      width: 20,
      height: '100%',
      transform: 'translateX(-50%)',
      boxShadow: `
        inset 3px 0 3px -0px rgba(0, 0, 0, 0.4),
        inset -3px 0 3px -0px rgba(0, 0, 0, 0.4),
        3px 0 3px -0px rgba(0, 0, 0, 0.3),
        -3px 0 3px -0px rgba(0, 0, 0, 0.3)
      `
    },

    // Pages shadow
    '.stf__block': {
      boxShadow: `
        rgba(0, 0, 0, 0.4) 0px 2px 4px,
        rgba(0, 0, 0, 0.3) 0px 7px 13px -3px,
        rgba(0, 0, 0, 0.2) 0px -2px 0px inset,

        rgba(0, 0, 0, 0.35) 0px 15px 20px,
        rgba(0, 0, 0, 0.25) 0px 10px 20px,
        rgba(0, 0, 0, 0.25) 0px 10px 20px,

        // Pages
        rgba(255, 255, 255, 1) 0px 1px 1px 1px,
        rgba(255, 255, 255, 1) 0px 1px 1px 1px
      `
    }
  },
  bookPage: {
    top: 0,
    display: 'flex',
    flexDirection: 'column',
    padding: 15,
    height: '100%',
    // overflow: 'hidden',

    '.pageContent': {
      display: 'flex',
      height: '100%',
      width: '100%'
    },

    '.pageImage': {
      display: 'flex',
      flexGrow: 1
    },

    '.pageTitle': {
      display: 'flex',
      textAlign: 'center',
      width: '100%',
      justifyContent: 'center',
      fontSize: '1.7rem',
      fontWeight: 'bold'
    },

    '.sparkles': {
      width: '100%',
      position: 'absolute',
      height: '100%'
    },

    '.featuresText': {
      display: 'flex',
      position: 'absolute',
      top: 0,
      height: '100%',
      width: '100%',
      left: 0,
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 40
    },

    // Page shading
    '&::after': {
      content: '""',
      position: 'absolute',
      width: '100%',
      height: '100%',
      bottom: 0,
      right: 0,
      background: `
        linear-gradient(
          to right,
          rgba(0,0,0,0.25) 0%,
          rgba(0,0,0,0.1) 20%,
          rgba(0,0,0,0) 40%,
          rgba(0,0,0,0) 80%,
          rgba(0,0,0,0) 92%,

          rgba(0,0,0,0.10) 99%,
          rgba(0,0,0,0.35) 100%
        )
      `
    },

    '&.isOdd': {
      '&::after': {
        content: '""',
        position: 'absolute',
        width: '100%',
        height: '100%',
        bottom: 0,
        right: 0,
        background: `
          linear-gradient(
            to right,
            rgba(0,0,0,0.4) 0%,
            rgba(0,0,0,0.3) 20%,
            rgba(0,0,0,0) 100%),
          linear-gradient(
            to right,
            rgba(0,0,0,0.3) 0%,
            rgba(0,0,0,0.2) 2%,
            rgba(0,0,0,0.15) 5%,
            rgba(0,0,0,0) 20%,
            rgba(0,0,0,0) 100%)
        `
      }
    }
  },

  typer: {
    position: 'fixed',
    bottom: 10,
    width: '90%',
    borderRadius: 20,
    background: '#FFF',

    '.typerTitle': {
      display: 'flex',
      textAlign: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      fontSize: '1rem',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.8rem'
      }
    }
  }
});
export default landingHeroStyle;
